import { CaosSynchronizationConfiguration } from "@/model/data/caosConfiguration/CaosSynchronizationConfiguration";
import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";
import { ApiGenericResponse } from "../ApiGenericResponse";

const ENDPOINT = "/caosconfiguration/usersync/save";

export class SaveCaosUserSyncConfigurationCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "post";
    payload: SaveCaosUserSyncConfigurationReqData;

    constructor(config: CaosSynchronizationConfiguration, installationsNames: Array<string>) {
        super();
        this.payload = new SaveCaosUserSyncConfigurationReqData(config, installationsNames);
    }

    public async execute(): Promise<ApiGenericResponse> {
        let res = await this.executeCommand(this.payload);
        return new ApiGenericResponse(res);
    }
}

export class SaveCaosUserSyncConfigurationReqData {
    configuration: CaosSynchronizationConfiguration;
    installationsNames: Array<string>;

    constructor(configuration: CaosSynchronizationConfiguration, installationsNames: Array<string>) {
        this.configuration = configuration;
        this.installationsNames = installationsNames;
    }
}
